import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Campaigns API
export const campaignsAPI = {
  getAll: (params) => api.get('/api/campaigns', { params }),
  getOne: (id) => api.get(`/api/campaigns/${id}`),
  create: (data) => api.post('/api/campaigns', data),
  getMetrics: (id, days = 30) => api.get(`/api/campaigns/${id}/metrics`, { params: { days } }),
};

// Recommendations API
export const recommendationsAPI = {
  generate: (data) => api.post('/api/recommendations/generate', data),
  getAll: (params) => api.get('/api/recommendations', { params }),
  submitFeedback: (data) => api.post('/api/recommendations/feedback', data),
  getAlignment: () => api.get('/api/recommendations/alignment'),
};

// Scenarios API
export const scenariosAPI = {
  simulate: (data) => api.post('/api/scenarios/simulate', data),
  monteCarlo: (data) => api.post('/api/scenarios/monte-carlo', data),
};

// Creative API
export const creativeAPI = {
  analyze: (data) => api.post('/api/creative/analyze', data),
  getAssets: (campaignId) => api.get('/api/creative/assets', { params: { campaign_id: campaignId } }),
};

// Chat API
export const chatAPI = {
  query: (data) => api.post('/api/chat/query', data),
};

// Admin API
export const adminAPI = {
  getStats: () => api.get('/api/admin/stats'),
  runTimeMachine: (data) => api.post('/api/admin/time-machine', data),
  getKnowledgeGraph: () => api.get('/api/admin/knowledge-graph'),
};

// Alerts API
export const alertsAPI = {
  getAll: (params) => api.get('/api/alerts', { params }),
  generate: () => api.post('/api/alerts/generate'),
  acknowledge: (id) => api.put(`/api/alerts/${id}/acknowledge`),
};

export default api;
